import React, { useState, useEffect, useMemo } from "react"
import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider, responsiveFontSizes } from "@mui/material/styles"
import {
  Box,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Tooltip,
  Checkbox,
  FormControl,
  FormHelperText,
  FormControlLabel,
} from "@mui/material"
import {
  MaterialReactTable,
  // createRow,
  useMaterialReactTable,
} from "material-react-table"
import EjecutarAccionIcon from "../../../assets/iconos/EjecutarAccion.ico"
import CustomTooltip from "../../../components/ToolTip"
import ImprimirIcon from "../../../assets/iconos/Impresion.ico"
import { MRT_Localization_ES } from "material-react-table/locales/es"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import DetalleImpresion from "../../Zonas/components/DetalleImpresion"
import Alert from "@mui/material/Alert"
import Swal from "sweetalert2"
import { useQuery, useQueryClient, useMutation, dataTagSymbol } from "@tanstack/react-query"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import BackIcon from "../../../components/BackIcon"
import GrabarIcon from "../../../assets/iconos/Grabar.ico"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../components/CustomBackdrop"
import CustomTextField from "../../../components/CustomTextField"

import AsociacionesPdf from "../components/AsociacionesPdf"
import ProvAsociadosGrid from "../components/ProvAsociadosGrid"
import FiltrosProovedores from "../components/FiltrosProveedores"
import ProvNoAsociadosGrid from "../components/ProvNoAsociadosGrid"
//  crear funciona como un mantenedor normal y devuelve a la pagina de opciones
//  estilo del formulario
const ClienteBox = styled(Box)({
  gridArea: "Cliente",
})
const NombreBox = styled(Box)({
  gridArea: "Nombre",
})
const IdBox = styled(Box)({
  gridArea: "Id",
})
const EstadoBox = styled(Box)({
  gridArea: "Estado",
})
// Contenedor de campos de busqueda
const Container = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
    "Cliente Cliente Nombre Nombre Nombre Nombre Id Id Id Id Estado Estado"
  `,
  gap: "8px",
  alignItems: "center",

  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(6, 1fr)",
    gridTemplateAreas: `
      "Cliente Cliente Cliente Nombre Nombre Nombre"
      "Id Id Id Estado Estado Estado"
    
    `,
  },
}))

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))
const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const AsociarClienteProveedor = () => {
  const { id } = useParams()
  const location = useLocation()
  const datoSeleccionado = location.state
  const clienteCiaCodigo = datoSeleccionado.ciacodigo
  // codigo del cliente
  const clienteCodigoActual = datoSeleccionado.clicodigo
  const clienteNombreActual = datoSeleccionado.clinombre
  const clienteIdActual = datoSeleccionado.cliruc
  const clienteEstadoActual = datoSeleccionado.clistatus

  const datosActualesCliente = {
    clicodigo: clienteCodigoActual,
    clinombre: clienteNombreActual,
    cliruc: clienteIdActual,
    clistatus: clienteEstadoActual,
  }

  const [openModal, setOpenModal] = useState(false)
  const [infoGenerada, setInfoGenerada] = useState([])

  const navigate = useNavigate()
  // estados de elementos del forrmulario
  // estados de los filtros
  const [error, setError] = useState(false)
  const [idCliente, setId] = useState(clienteIdActual)
  const [nombre, setNombre] = useState(clienteNombreActual)

  // proovedores que selecciono grilla
  const [proveedoresSeleccionados, setProveedoresSeleccionados] = useState([])
  // proveedores que ya estaban relacionadas al clientes
  const [proveedoresIniciales, setProveedoresIniciales] = useState([])
  const [infoPdf, setInfoPdf] = useState(proveedoresIniciales)
  useEffect(() => {
    setInfoPdf(proveedoresIniciales)
  }, infoPdf)
  const handleNumericInput = (value, setValue) => {
    // Allow empty value, integers, or decimals
    if (/^\d*\.?\d*$/.test(value)) {
      setValue(value)
      setError(false) // No error if the input is valid
    } else {
      setError(true) // Show error if the input is invalid
    }
    console.log(idCliente)
  }
  useEffect(() => {
    setId(idCliente)
    console.log(idCliente)
  }, [idCliente])
  const handleNombreCliente = (event) => {
    setNombre(event.target.value)
  }
  useEffect(() => {
    setNombre(nombre)
    console.log(nombre)
  }, [nombre])

  const Estados = [
    { value: "A", description: "ACTIVO" },
    { value: "I", description: "INACTIVO" },
  ]
  const findEstado = (estadoCurrent) => {
    const result = Estados.find((estado) => estado.value === estadoCurrent)
    return result
  }
  const [estadoCliente, setEstadoCliente] = useState(findEstado(clienteEstadoActual))
  const [isFormValid, setIsFormValid] = useState(false)
  const { mutateAsync: createAsociacion, isPending: isCreatingAsociacion } = useCreateAsociacion()
  const { mutateAsync: deleteAsociacion, isPending: isDeletingAsociacion } = useDeleteAsociacion()
  const { mutateAsync: updateCliente, isPending: isUpdatingCliente } = useUpdateCliente()
  const seleccionarProvsDelete = (prevProvs, currentProvs) => {
    // funcion que dado ambos arreglos me devuelve un arreglo con las bodegas de debo desasociar y otro con las que debo asociar
    const setIniciales = new Set(prevProvs)
    const setActuales = new Set(currentProvs)
    // Bodegas a desasociar: están en las iniciales pero no en las actuales
    const provsDesasociar = [...setIniciales].filter((prov) => !setActuales.has(prov))
    return { deletes: provsDesasociar }
  }
  function useUpdateCliente() {
    const queryClient = useQueryClient()
    return useMutation({
      mutationFn: async (cliente) => {
        // send api update request here
        // send api update request here
        const options = {
          method: "PUT",
          body: JSON.stringify(cliente),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json", options.body)
        let response = await fetchwrapper(`/AsociacionCliBod/updateCliente`, options)

        response = response.json()
        console.log(response)
        return response
      },
      // client side optimistic update
      onMutate: (newCliente) => {
        console.log(newCliente, "onmutate")
        queryClient.setQueryData(["Cliente", id], (prevCliente) => ({
          ...newCliente,
        }))
      },
      onSuccess: () => {
        // Invalidate and refetch client data
        queryClient.invalidateQueries(["Cliente", id])
        queryClient.invalidateQueries(["proovedoresXcliente"])
      },
      // onSettled: () => queryClient.invalidateQueries({ queryKey: ['bancoDePreguntas'] }), //refetch bancoDePreguntas after mutation, disabled for demo
    })
  }
  function useDeleteAsociacion() {
    const queryClient = useQueryClient()
    return useMutation({
      mutationFn: async (arregloDesasoci) => {
        const options = {
          method: "DELETE",
          body: JSON.stringify(arregloDesasoci),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log(options.body)
        const response = await fetchwrapper(`/AsociacionProvCli/eliminarAsociacion`, options)
        return response
      },

      // actualizacion optimista
      onMutate: (clicodigo) => {
        queryClient.setQueryData(["Asociaciones"], (prevAsociaciones) =>
          prevAsociaciones?.filter((asoci) => asoci.clicodigo !== clicodigo),
        )
      },
      onSuccess: () => {
        // Invalidate and refetch client data
        queryClient.invalidateQueries(["Cliente", id])
        queryClient.invalidateQueries(["clienteXproveedor"])
      },
    })
  }
  function useCreateAsociacion() {
    const queryClient = useQueryClient()
    return useMutation({
      mutationFn: async (asociaciones) => {
        // send api update request here
        // send api update request here
        const options = {
          method: "POST",
          body: JSON.stringify(asociaciones),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json", options.body)
        let response = await fetchwrapper(`/AsociacionProvCli/crearAsociacion`, options)

        response = response.json()
        console.log(response)
        return response
      },

      // client side optimistic update
      onMutate: (newAsociacion) => {
        console.log(newAsociacion, "onmutate")
        queryClient.setQueryData(["Asociacion", newAsociacion.id], (prevAsociacion) => ({
          ...newAsociacion,
        }))
      },
      onSuccess: () => {
        // Invalidate and refetch client and warehouse data
        queryClient.invalidateQueries(["Cliente", id])
        queryClient.invalidateQueries(["clienteXproveedor"])
      },
      // onSettled: () => queryClient.invalidateQueries({ queryKey: ['bancoDePreguntas'] }), //refetch bancoDePreguntas after mutation, disabled for demo
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!isFormValid) {
      Swal.fire({
        icon: "error",
        title: "Campos Incompletos",
        text: "Por favor complete los campos EXT para todas las filas seleccionadas.",
      })
      return
    }

    try {
      const eliminar = seleccionarProvsDelete(proveedoresIniciales, proveedoresSeleccionados)
      console.log("proveedores a elimianr", eliminar.deletes)
      const asociar = proveedoresAsociar
      console.log("proveedores a asociar", asociar)
      const asociaciones = {
        clicodigo: clienteCodigoActual,
        proveedoresAsociar: asociar,
      }
      const desasociaciones = {
        clicodigo: clienteCodigoActual,
        proveedoresEliminar: eliminar.deletes,
      }
      const cliente = {
        clicodigo: clienteCodigoActual,
        nombreCliente: nombre,
        idCliente,
      }
      if (asociar.length !== 0) {
        await createAsociacion(asociaciones)
      }
      if (eliminar.deletes.length !== 0) {
        await deleteAsociacion(desasociaciones)
      }
      updateCliente(cliente)

      // Refetch para asegurarnos que los datos están correctamente sincronizados
      await refetchProveedores()
      Swal.fire({
        icon: "success",
        title: "Operación exitosa",
        text: "Se guardaron los cambios",
      })
      navigate("/home/dashboard/AsociacionClientesProveedor")
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "No se pudieron guardar los cambios",
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/home/dashboard/AsociacionClientesProveedor") // Navega de vuelta cuando se cierre el SweetAlert
      })
    }
  }

  const [proovedores, setProveedores] = useState([])
  const [proveedoresDisponibles, setProveedoresDisponibles] = useState([])
  const [searchAttempted, setSearchAttempted] = useState(false)
  const [proveedoresFiltro, setProveedoresFiltro] = useState([])
  const {
    data: fetchedProveedores = { asociados: [], noAsociados: [] },
    isError: isLoadingProveedoresError,
    isFetching: isFetchingProveedores,
    isLoading: isLoadingProveedores,
    refetch: refetchProveedores,
  } = useGetAllProveedores()
  function useGetAllProveedores() {
    return useQuery({
      queryKey: ["proveedoresXcliente"],
      queryFn: async () => {
        const options = {
          method: "POST",
          body: JSON.stringify({
            clicodigo: clienteCodigoActual,
          }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log(options.body)
        // send api request here
        let response = await fetchwrapper("/AsociacionProvCli/getAllProovedores", options)
        response = await response.json()
        console.log(response)
        return { asociados: response.asociados, noAsociados: response.desasociados }
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: false, // Añade esta línea para evitar refetch al reconectar
      // enabled: !searchAttempted && !isFirstTime,
    })
  }
  useEffect(() => {
    setProveedores(fetchedProveedores.asociados)
    console.log(proovedores)
  }, [fetchedProveedores])
  useEffect(() => {
    // if (searchAttempted) {
    setProveedoresDisponibles(fetchedProveedores.noAsociados)
    //   console.log(proveedoresDisponibles)
    // }
  }, [fetchedProveedores, searchAttempted])
  useEffect(() => {
    setProveedoresFiltro(proveedoresFiltro)
  }, [proveedoresFiltro])
  const EstadosProv = [
    { value: "A", description: "ACTIVO" },
    { value: "I", description: "INACTIVO" },
  ]
  // FILTROS PARA BUSCAR NUEVOS PROVEEDORE
  const [expanded, setExpanded] = useState(false)
  // estados de los filtros
  const [errorProv, setErrorProv] = useState(false)
  const [idProv, setIdProv] = useState("")
  const [codigoProv, setCodigoProv] = useState("")
  const [nombreProv, setNombreProv] = useState("")
  const [estadoProv, setEstadoProv] = useState(EstadosProv[0])
  // proveedores que mando a asociar
  const [proveedoresAsociar, setProveedoresAsociar] = useState([])

  const handleExpandAccordion = () => {
    setExpanded((prevExpanded) => !prevExpanded)
  }

  const obtenerDatosFiltro = () => {
    return {
      procodigo: codigoProv,
      proruc: idProv,
      pronombre: nombreProv,
      prostatus: estadoProv.value,
    }
  }
  function filtrarObjetos(filtros, objetos) {
    // Convertimos cada propiedad de los filtros en condiciones de búsqueda
    return objetos.filter((objeto) => {
      return Object.keys(filtros).every((key) => {
        // Si el filtro está vacío o nulo, no lo consideramos
        if (!filtros[key]) return true

        // Si la propiedad del objeto también está vacía o nula, no lo consideramos
        if (!objeto[key]) return false

        // Realizamos una comparación tipo LIKE para strings (incluye minúsculas y mayúsculas)
        return objeto[key].toString().toLowerCase().includes(filtros[key].toString().toLowerCase())
      })
    })
  }
  const resetAllFilters = () => {
    setIdProv("")
    setCodigoProv("")
    setNombreProv("")
    setEstadoProv(EstadosProv[0])
  }
  const handleFiltroProv = (e) => {
    e.preventDefault()
    const filtros = obtenerDatosFiltro()
    const resultado = filtrarObjetos(filtros, proveedoresDisponibles)
    setProveedoresFiltro(resultado)
    console.log(proveedoresFiltro)
    // setSearchAttempted(true)

    setExpanded(false)
    resetAllFilters()
  }
  const handleOpenModal = () => {
    setInfoGenerada(infoPdf)
    console.log("infoGenerada", infoGenerada) // Asigna los datos de la tabla al estado
    setOpenModal(true)
  }
  const handleCloseModal = () => {
    setOpenModal(false)

    navigate("/home/dashboard/AsociacionClientesProveedor")
  }
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Asociacion de Proveedores a Cliente</b>
        </div>
        <Box className={StyledRoot}>
          <Tooltip title="Grabar">
            <Button style={{ fontSize: "0.9vw" }} onClick={handleSubmit}>
              <img src={GrabarIcon} alt="Grabar" style={{ width: "40px" }} />
            </Button>
          </Tooltip>
          <Tooltip title="Imprimir">
            <Button color="primary" onClick={handleOpenModal} sx={{ marginBottom: "15px" }}>
              <img src={ImprimirIcon} alt="Imprimir" style={{ width: "30px" }} />
            </Button>
          </Tooltip>
          <DetalleImpresion
            open={openModal}
            handleClose={handleCloseModal}
            infoGenerada={proveedoresIniciales}
            nombrePdf={"ASOCIACIONES PROOVEDORES A CLIENTES"}
            PdfComponent={AsociacionesPdf}
          />
          <Container>
            <ClienteBox>
              <InputLabel>Cliente</InputLabel>
              <TextField disabled fullWidth value={clienteCodigoActual} />
            </ClienteBox>
            <NombreBox>
              <InputLabel>Nombre</InputLabel>
              <TextField fullWidth value={nombre} onChange={handleNombreCliente} />
            </NombreBox>
            <IdBox>
              <InputLabel>Identificacion</InputLabel>
              <FormControl fullWidth error={error}>
                <TextField
                  value={idCliente}
                  onChange={(e) => handleNumericInput(e.target.value, setId)}
                  error={error} // Set error state in TextField
                  helperText={error ? "Por favor ingresa solo valores numéricos." : ""}
                />
                {error && <FormHelperText>El valor ingresado no es válido.</FormHelperText>}
              </FormControl>
            </IdBox>
            <EstadoBox>
              <InputLabel>Estado</InputLabel>
              <Select
                fullWidth
                disabled
                labelId="estadoClientesCB"
                value={estadoCliente.value}
                onChange={(e) => {
                  const selectedValue = e.target.value
                  const clienteestado = Estados.find((estado) => estado.value === selectedValue)
                  setEstadoCliente(clienteestado)
                  //   clearAll(tipoPregunta)
                }}
              >
                {Estados.map((estado) => (
                  <MenuItem key={estado.value} value={estado.value}>
                    {estado.description}
                  </MenuItem>
                ))}
              </Select>
            </EstadoBox>
          </Container>
        </Box>
        <ProvAsociadosGrid
          fetchedInfo={proovedores}
          isLoadingInfoError={isLoadingProveedoresError}
          isLoadingInfo={isLoadingProveedores}
          isFetchingInfo={isFetchingProveedores}
          setProveedores={setProveedores}
          refetch={refetchProveedores}
          // bodegasSeleccionadas --> bodegas que se seleccionan al inicio
          selectedProvs={proveedoresSeleccionados}
          setSelectedProvs={setProveedoresSeleccionados}
          // bodegas Inciales-->bodegas cargadas al inicio
          provsAnteriores={proveedoresIniciales}
          setProvsAnteriores={setProveedoresIniciales}
        ></ProvAsociadosGrid>
        <CustomBackdrop isLoading={isCreatingAsociacion || isDeletingAsociacion || isUpdatingCliente} />
        <CustomTooltip title={"Buscar Proveedores"}>
          <Button style={{ fontSize: "0.9vw" }} onClick={handleFiltroProv}>
            <img src={EjecutarAccionIcon} alt="Crear" style={{ width: "40px", margin: "10px" }} />
          </Button>
        </CustomTooltip>
        <FiltrosProovedores
          codigoProv={codigoProv}
          idProv={idProv}
          estadoProv={estadoProv}
          nombreProv={nombreProv}
          setCodigoProv={setCodigoProv}
          setIdProv={setIdProv}
          setEstadoProv={setEstadoProv}
          setNombreProv={setNombreProv}
          expanded={expanded}
          setExpanded={setExpanded}
          error={errorProv}
          setError={setErrorProv}
          handleExpandAccordion={handleExpandAccordion}
          Estados={EstadosProv}
        ></FiltrosProovedores>
        <ProvNoAsociadosGrid
          fetchedInfo={proveedoresFiltro}
          isLoadingInfoError={isLoadingProveedoresError}
          isLoadingInfo={isLoadingProveedores}
          isFetchingInfo={isFetchingProveedores}
          refetch={refetchProveedores}
          setProveedoresNoAsociados={setProveedoresFiltro}
          selectedAvProvs={proveedoresAsociar}
          setSelectedAvProvs={setProveedoresAsociar}
          setIsFormValid={setIsFormValid}
        ></ProvNoAsociadosGrid>
      </div>
    </ThemeProvider>
  )
}

export default AsociarClienteProveedor
